import { render } from "./VerifyEmailButton.vue?vue&type=template&id=12bb5a1e"
import script from "./VerifyEmailButton.vue?vue&type=script&lang=js"
export * from "./VerifyEmailButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Auth/VerifyEmailButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12bb5a1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12bb5a1e', __exports__)) {
    api.reload('12bb5a1e', __exports__)
  }
  
  module.hot.accept("./VerifyEmailButton.vue?vue&type=template&id=12bb5a1e", () => {
    api.rerender('12bb5a1e', render)
  })

}


export default __exports__